import React from "react";

import axios from "axios";

import { homepage } from "../../constants/common";
import "./Images.css";

export default class Images extends React.Component {
  state = {
    images: [],
    page: 0,
    pageSize: 0,
  };

  componentDidMount() {
    axios.get(homepage + "/get_images.php").then((res) => {
      const images = res.data;
      images.reverse();
      this.setState({ images: images });
    });
  }

  nextPage() {
    if (
      this.state.page * this.state.pageSize + this.state.pageSize <
      this.state.images.length
    )
      this.setState({ page: this.state.page + 1 });
  }
  previousPage() {
    if (this.state.page > 0) this.setState({ page: this.state.page - 1 });
  }

  getNumberOfColumns() {
    let width = window.innerWidth - (window.innerWidth % 368);
    return Math.floor(width / 368);
  }

  getWidth() {
    return 5 + this.getNumberOfColumns() * 368;
  }

  render() {
    var location = "convert_images/";
    var items = [];

    this.state.pageSize = this.getNumberOfColumns() * 3;
    for (let i = 0; i < this.state.pageSize; i++) {
      items.push(
        String(
          this.state.images[i + this.state.page * this.state.pageSize]
        ).replace(location, "")
      );
    }

    location = "/" + location;

    return (
      <div
        style={{
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            margin: "auto",
            width: "30%",
            textAlign: "center",
          }}
        >
          <br></br>
          <h2 className="convertTitle HeadingTwo">Converted Images</h2>
        </div>
        <br></br>
        <div
          style={{
            height: "425px",
            width: this.getWidth(),
            margin: "auto",
          }}
        >
          {items.map((item) => (
            <div class="gallery">
              <a download href={homepage + location + item} title={item}>
                <img
                  src={homepage + location + item}
                  alt="Image"
                  width="256"
                  height="92"
                ></img>
              </a>
            </div>
          ))}
        </div>
        <div
          style={{
            margin: "auto",
            width: "50%",
            paddingTop: "50px",
          }}
        >
          <p
            style={{
              float: "left",
            }}
          >
            <button className="button" onClick={() => this.previousPage()}>
              Previous
            </button>
          </p>
          <p
            style={{
              float: "right",
            }}
          >
            <button className="button" onClick={() => this.nextPage()}>
              Next
            </button>
          </p>
        </div>
      </div>
    );
  }
}
